<template>
    <div id="AxxessSurveyModal">
        <div class="main-div">
            <table class="main-table" cellspacing="0" cellpadding="0">
                <tbody>
                    <tr>
                        <td>
                            <div>
                                <h3 class="primary-title mb-4">HELP US HELP YOU</h3>
                                <p class="content-paragraph">
                                    Axxess is a trusted partner in your success. Your feedback ensures we meet your needs and deliver solutions that make it easier to do what you love.
                                </p>

                                <table width="100%" border="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <table
                                                    style="
                                                        background-color: #4d85ff;
                                                        width: 220px;
                                                        height: 40px;
                                                        margin-right: 10px;
                                                        margin-left: 30px;
                                                    "
                                                    border="0"
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                style="text-align: center; cursor: pointer"
                                                                @click="ok()"
                                                            >
                                                                <span
                                                                    style="
                                                                        font-size: 14px;
                                                                        font-family: helvetica, arial, sans-serif;
                                                                    "
                                                                    ><a style="text-decoration: none; color: #ffffff"
                                                                        >TAKE SURVEY</a
                                                                    ></span
                                                                >
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td>
                                                <table
                                                    style="
                                                        background-color: #b9243c;
                                                        width: 220px;
                                                        height: 40px;
                                                        border: 1px solid white;
                                                    "
                                                    border="0"
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                style="text-align: center; cursor: pointer"
                                                                @click="remindMeLater()"
                                                            >
                                                                <span
                                                                    style="
                                                                        font-size: 14px;
                                                                        font-family: helvetica, arial, sans-serif;
                                                                    "
                                                                >
                                                                    <a style="text-decoration: none; color: #ffffff"
                                                                        >REMIND ME LATER</a
                                                                    ></span
                                                                >
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                        <td valign="top" width="267" height="386" style="position: relative">
                            <img src="../../../assets/images/npsbg.png" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<style src="./SurveyModal.scss"></style>
<script lang="ts" src="./SurveyModal.ts"></script>